module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Honey_diameter.4bae3ad2.png";